import React from 'react';
import {
  Account_balance,
  addPathToList,
  Asset_requirements_paragraph,
  Configure_customer_sees, File_type,
  getSubCategoryId,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import AssetRequirements from '../components/PanelsComponents/General/AssetRequirements';

//= ========================================================================
const Panel_C02_AccountInfoBalance = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'account_balance',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Account_balance}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/balance/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/balance/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={Configure_customer_sees}
      language={language}
    >
      <AssetRequirements paragraph={Asset_requirements_paragraph} details={File_type} />
    </FullPagePanel>
  );
};

export default Panel_C02_AccountInfoBalance;
